const getLocalePartialUrl = (locale: string) =>
  locale === 'en' ? '/' : `/${locale}/`;

export default getLocalePartialUrl;
